function processTermsAndCondition(content: string) {
  const lowerContent = content.toLowerCase();

  const hasBodyTag = lowerContent.includes("<body");

  let cleanedContent = content;

  if (hasBodyTag) {
    cleanedContent = content.replace(
      /<html[^>]*>|<\/html>|<!DOCTYPE[^>]*>|<body[^>]*>|<\/body>/gi,
      "",
    );
  }
  cleanedContent = cleanedContent.replaceAll(/<meta[^>]*>/gi, "");
  cleanedContent = cleanedContent.replaceAll(/<title[^>]*>.*?<\/title>/gi, "");
  cleanedContent = cleanedContent.replaceAll(/<head[^>]*>.*?<\/head>/gi, "");
  return `
  <!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8">
  </head>
  <body>
    ${cleanedContent}
  </body>
  </html>
  `.trim();
}

export default processTermsAndCondition;
